import { jsx } from 'react/jsx-runtime';

const SvgFormRadioDot = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z" }) }));

export { SvgFormRadioDot as default };
//# sourceMappingURL=FormRadioDot.es.js.map
